import { createContext, useContext, Dispatch, SetStateAction } from "react";


interface IControlUIContext {
  expandedReports: boolean;
  expandReports: Dispatch<SetStateAction<boolean>>;
  chainLength: number;
  setChainLength: Dispatch<SetStateAction<number>>;
}

const ControlUIContext = createContext<IControlUIContext>({
  expandedReports: false,
  expandReports: () => {},
  chainLength: 0,
  setChainLength: () => {},
});

export default ControlUIContext;

export const useControlUI = () => useContext(ControlUIContext);
